"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusStyles = void 0;

var tslib_1 = require("tslib");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = require("styled-components");

var border_1 = require("./border");

var defaultStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  &:focus-within {\n    ", "\n  }\n"], ["\n  &:focus-within {\n    ", "\n  }\n"])), border_1.blueBorder);
var inverseStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  &:focus-within {\n    ", "\n  }\n"], ["\n  &:focus-within {\n    ", "\n  }\n"])), border_1.whiteBorder);
exports.focusStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), defaultStyles, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', inverseStyles);
});
var templateObject_1, templateObject_2, templateObject_3;